import AdminFoodView from './views/AdminFoodView.vue'

import ViewWithChild from '../ViewWithChild.vue'

import AdminOverviewReportsContainer from './components/AdminOverviewReportsContainer.vue'
import AverageEggProduction from './components/AverageEggProduction.vue'

import AddLayerBatch from './components/AddLayerBatch.vue'
import AdminReportsPerBatchContainer from './components/AdminReportsPerBatchContainer.vue'
import ManageLayerBatches from './components/ManageLayerBatches.vue'

import BulkImportView from './views/BulkImportView.vue'

export default [
  {
    path: '/admin/layers/overview-reports', navHide: true, component: ViewWithChild, meta: { role: 'LayerAdmin', layout: 'fluid', title: 'Overview' },
    children: [
      { path: 'charts', name: 'admin/layers/overview/charts', component: AdminOverviewReportsContainer, meta: { role: 'LayerAdmin', title: 'Charts' } },
      { path: 'egg-production', name: 'admin/layers/overview/egg-production', component: AverageEggProduction, meta: { role: 'LayerAdmin', title: 'Egg Production', layout: 'narrow' } },
    ]
  },

  {
    path: '/admin/layers/batches', navHide: true, component: ViewWithChild, meta: { role: 'LayerAdmin', layout: 'fluid', title: 'Batches' },
    children: [
      { path: 'add', name: 'admin/layers/batches/add', component: AddLayerBatch, meta: { role: 'LayerAdmin', title: 'New Batch', layout: 'narrow' } },
      { path: 'reports-per-batch', name: 'admin/layers/batches/reports-per-batch', component: AdminReportsPerBatchContainer, meta: { role: 'LayerAdmin', title: 'Reports' } },
      { path: 'manage', name: 'admin/layers/batches/manage', component: ManageLayerBatches, meta: { role: 'LayerAdmin', title: 'Manage', layout: 'narrow' } },
    ]
  },

  { path: '/admin/layers/food', name: 'admin/layers/food', component: AdminFoodView, meta: { role: 'LayerAdmin', layout: 'fluid', title: 'Food' } },

  { path: '/admin/layers/bulk-import', name: 'admin/layers/bulk-import', component: BulkImportView, meta: { role: 'LayerAdmin', layout: 'fluid', title: 'Bulk Import' } },
]



// WEBPACK FOOTER //
// ./src/layerAdmin/routes.js